jQuery(document).ready(function($) {
	// $('.current-currency').each(function(){
	// 	var text = $('.currency_switch_form button.active').text();
	// 	$(this).text(text);
	// });

	$('#checkout_login .woocommerce-form-login > p:first-child').html('If you have a BioPods account, please enter your Username and Password in the boxes below.<br><br>If you are a new customer, to proceed to the Billing and Shipping section, please click on the Skip Login button below.');

	$('.checkout-footer .current-currency').each(function(){
		var text = $('button.currency_button.active').text();
		$(this).text(text);
	});

	$('.checkout-footer .currency-button-switch').on('click', function(){
		$('button.currency_button:not(.active)').click();
	});

	$('.currency-button-switch').on('click', function(){
		$('button.currency_button:not(.active)').click();
	});


	if($('.page-id-94').length){
		$('main').find('.btn').addClass('modal-trigger').attr('href', '#registration-modal');
	}


	setTimeout(function(){
		$('#rm_form_page_form_1_1_1').find('.rm-two-columns-wrap:first-child .rmrow:first-child .rmradio li:first-child label').text('Practicing');
		$('#rm_form_page_form_1_1_1').find('.rm-two-columns-wrap:first-child .rmrow:first-child .rmradio li:last-child label').text('Student');
	}, 1000);

	jQuery.fn.scrollTo = function(elem, speed) {
	    $(this).animate({
	        scrollTop:  $(this).scrollTop() - $(this).offset().top + $(elem).offset().top
	    }, speed == undefined ? 1000 : speed);
	    return this;
	};

	$('body').on('click', 'img[src*="icon-pin@2x"]', function(){
		var storeID = $('.wpsl-info-window').data('store-id');
		$('.wpsl-store-location').each(function(){
			if($(this).data('store-id') == storeID){
				$(this).addClass('is-active');
				$('#wpsl-stores').scrollTo($(this), 1000);
			}else{
				$(this).removeClass('is-active');
			}
		});
		console.log($('.gm-style-iw button').length);
		$('.gm-style-iw button').bind( "click", function() {
		  inactiveSearchResults();
		});
	});

	function inactiveSearchResults(){
		$('.wpsl-store-location').removeClass('is-active');
		console.log('test');
	}

	$('body').on('click', '.wpsl-store-location', function(){
		$(this).find('a.wpsl-store-details').click();
		$('.wpsl-store-location').removeClass('is-active');
		$(this).addClass('is-active');
		$('.gm-style-iw button').bind( "click", function() {
		  inactiveSearchResults();
		});
	});

	$('body').on('click', '.wpsl-store-location p.title strong a', function(e){
		e.preventDefault();
		window.open($(this).attr('href'));
	});


	//show 2 pairs screen
	$('input[type="radio"][name="stimsole-pairs"]').on('click', function(){
	  var numberOfPairs = $(this).val();
	  if(numberOfPairs == 1){
	    $('.get-stimsoles-swap[data-pairs="single"]').show();
	    $('.get-stimsoles-swap[data-pairs="double"]').hide();
			$('.pairs-subtext[data-pairs="single"]').show();
			$('.pairs-subtext[data-pairs="double"]').hide();
	  }else{
			$('.get-stimsoles-swap[data-pairs="single"]').hide();
  	    $('.get-stimsoles-swap[data-pairs="double"]').show();
			$('.pairs-subtext[data-pairs="single"]').hide();
			$('.pairs-subtext[data-pairs="double"]').show();
	  }
	});

	$('body').on('change', '#shipping_method input[type="radio"]', function(){
		console.log('change shipping');
		setTimeout(function(){
			updateCheckoutCart();
		}, 3000);
	});

	$('body').on('change','.quantity-form input[type="number"]',  function(){
		var qty = $(this).val();
		var max = $(this).attr('max');
		max = parseInt(max);
		qty = parseInt(qty);
		if(qty < 1){
			if(qty != ''){
				$(this).val("1");
			}
			qty = 1;
		}

		if(qty > max){
			$(this).val(max);
			$(this).parents('.quantity-form').find('.error-msg-small').remove();
			$(this).parents('.quantity-form').append('<p class="error-msg-small">Only '+max+' available in this size.</p>');
		}else{
			$(this).parents('.quantity-form').find('.error-msg-small').remove();
		}
	});

	$('body').on('keyup', '.quantity-form input[type="number"]', function(){
		var qty = $(this).val();
		var max = $(this).attr('max');
		max = parseInt(max);
		qty = parseInt(qty);
		if(qty < 1){
			if(qty != ''){
				$(this).val("1");
			}
			qty = 1;
		}

		if(qty > max){
			$(this).val(max);
			$(this).parents('.quantity-form').find('.error-msg-small').remove();
			$(this).parents('.quantity-form').append('<p class="error-msg-small">Only '+max+' available in this size.</p>');
		}else{
			$(this).parents('.quantity-form').find('.error-msg-small').remove();
		}

	});

	$('body').on('click', '.btn--save-cart-quantity', function(e){
		e.preventDefault();
		var cart_item_id = $(this).data('cart-item-id');
		var cart_item_quantity = $(this).parents('.quantity-form').find('input[type="number"]').val();
		$('#side-cart').addClass('is-loading');

		const updates = {};
		updates[cart_item_id] = cart_item_quantity;

		$.ajax({
		   type: "POST",
		   url: "/cart/update.js",
		   data: {
				updates: updates
			},
		   success: function (res) {
			   if (res) {
					updateSideCart();
					window.SAWCartCheck()
					 if($('.checkout-flex-wrapper').length){
						 updateCheckoutCart();
						 var currentTime = new Date();
						 var current_timestamp = Date.parse(currentTime);
						 $(".woocommerce-checkout-review-order-table").load(location.href + '?time=' + current_timestamp + " .woocommerce-checkout-review-order-table>*","");
						 console.log(location.href + '?time=' + current_timestamp + " .woocommerce-checkout-review-order-table>*");
					 }
			   }
		   }
		});
	});

	$('body').on('click', '.btn--edit-cart-item-quantity', function(e){
		e.preventDefault();
		$(this).parents('.quantity-form--parent').addClass('is-active');

	});

	$('.add-single-product--custom').on('click', function(e){
		e.preventDefault();
		var variation_id = $(this).parents('.shop-listings-product-row').find('.table-row-variant-selector').val();
		var qty = $(this).parents('.shop-listings-product-row').find('.quantity-row-selector').val();
		var product_id = $(this).parents('.shop-listings-product-row').data('product-id');
		var max_qty_option = $(this).parents('.shop-listings-product-row').find('.table-row-variant-selector').find('option:selected');
		var max_qty = max_qty_option.data('stock');
		if(!max_qty){
			var max_qty = $(this).parents('.shop-listings-product-row').find('.quantity-row-selector').attr('max');
		}
		if(qty <= max_qty){
			// console.log('in stock');
			// console.log(variation_id);
			// console.log(qty);
			// console.log(product_id);
			$(this).parents('.shop-listings-product-row').find('.error-msg-small').remove();
			$.ajax({
			   type: "POST",
			   url: woocommerce_params.ajax_url,
			   data: {action : 'add_variation_to_cart','variation_id' : variation_id, 'qty' : qty, 'product_id' : product_id},
			   success: function (res) {
				   if (res) {
					   updateSideCart();
					   var cartInstance = M.Sidenav.getInstance( $('#side-cart').get(0) );
			   			cartInstance.open();
					  console.log('response', res);
				   }
			   }
			});

		}else{
			console.log('not in stock');
			$(this).parents('.shop-listings-product-row').find('.error-msg-small').remove();
			$(this).parents('.shop-listings-product-row').find('.shop-listings-size').append('<p class="error-msg-small">Only '+max_qty+' available in this size.</p>');
		}
	});


	$('.add-single-kit--custom').on('click', function(e){
		e.preventDefault();
		var variation_id = $(this).parents('.starter-kit-panel').find('.starter-kit-variant-selector').val();
		var qty = $(this).parents('.starter-kit-panel').find('.quantity-row-selector').val();
		console.log(qty);
		var product_id = $(this).parents('.starter-kit-panel').data('product-id');
		if($(this).parents('.starter-kit-panel').find('.starter-kit-variant-selector').length){
			var max_qty_option = $(this).parents('.starter-kit-panel').find('.starter-kit-variant-selector').find('option:selected');
			var max_qty = max_qty_option.data('stock');
		}else{
			var max_qty = $(this).parents('.starter-kit-panel').find('.quantity-row-selector').attr('max');
		}
		console.log(max_qty);
		max_qty = parseInt(max_qty);
		qty = parseInt(qty);
		if(qty <= max_qty){
			console.log('in stock');
			console.log(qty);
			console.log(product_id);
			$(this).parents('.starter-kit-panel').find('.error-msg-small').remove();
			$.ajax({
			   type: "POST",
			   url: woocommerce_params.ajax_url,
			   data: {action : 'add_bundle_to_cart','variation_id' : variation_id, 'qty' : qty, 'product_id' : product_id},
			   success: function (res) {
				   if (res) {
					   updateSideCart();
					   var cartInstance = M.Sidenav.getInstance( $('#side-cart').get(0) );
			   			cartInstance.open();
					  //console.log('response', res);
				   }
			   }
			});

		}else{
			console.log('not in stock');
			$(this).parents('.starter-kit-panel').find('.error-msg-small').remove();
			$(this).parents('.starter-kit-panel').find('.shop-listings-size').append('<p class="error-msg-small">Only '+max_qty+' available in this size.</p>');
		}
	});

	// $('.quantity-row-selector').on('keyup', function(){
	// 	setQuantityPrice();
	// });

	// $('.quantity-row-selector').on('change', function(){
	// 	setQuantityPrice();
	// });

	$('.table-row-variant-selector').on('change', function(){
		var variation_id = $(this).val();
        var $this = $(this);
		$(this).parents('.shop-listings-product-row').find('.toggle-price').each(function(){
			var price_variation_id = $(this).data('id');
			if(variation_id == price_variation_id){
				$(this).addClass('is-active');
			}else{
				$(this).removeClass('is-active');
			}
		});

        var parentcls = $(this).parents('.shop-listings-product-row').find('.table-row-variant-selector');
        var totalvari = parentcls.length;
        var varitext = '';
        parentcls.each(function(index){
            var itemnumber = index+1;
			//alert(totalvari+' '+itemnumber);
            varitext += $(this).val();
            if(totalvari != itemnumber){
              varitext += ' / ';
            }
		});
        var ff = $(this).parents('.shop-listings-product-row').find('select[name="id"] option[title="'+varitext+'"]').prop('selected', true);
        //alert(ff);
		// setQuantityPrice();
	});

  

	$('.starter-kit-variant-selector').on('change', function(){
		var variation_id = $(this).val();
		$(this).parents('.starter-kit-panel').find('.toggle-price').each(function(){
			var price_variation_id = $(this).data('id');
			if(variation_id == price_variation_id){
				$(this).addClass('is-active');
			}else{
				$(this).removeClass('is-active');
			}
		});
		//setQuantityPrice();
	});

	function setQuantityPrice(){
		// $('.shop-listings-product-row').each(function(){
		// 	var qty = $(this).find('.quantity-row-selector').val();
		// 	if(qty < 1){
		// 		if(qty != ''){
		// 			$(this).val("1");
		// 		}
		// 		qty = 1;
		// 	}
		// 	var price = $(this).find('.toggle-price.block.is-active .row-subtotal').data('subtotal');
		// 	price = parseFloat(price).toFixed(2);
		// 	qty = parseFloat(qty).toFixed(2);
		// 	var newSubtotal = price * qty;
		// 	newSubtotal = newSubtotal.toFixed(2);
		// 	$(this).find('.toggle-price.block.is-active .row-subtotal').text('$' + newSubtotal);
		// });
	}

	$('.star-rating-select img').on('mouseover', function(){
		var rating = $(this).data('rating');
		if(!$(this).parents('.star-rating-select').hasClass('selected')){
			$('.star-rating-select img').each(function(){
				if($(this).data('rating') <= rating){
					$(this).attr('src', '/wp-content/themes/biopods/img/yellow-star.svg');
				}else{
					$(this).attr('src', '/wp-content/themes/biopods/img/yellow-star-hollow.svg');
				}
			});
		}
	});

	$('.star-rating-select img').on('mouseout', function(){
		if(!$(this).parents('.star-rating-select').hasClass('selected')){
			$('.star-rating-select img').each(function(){
				$(this).attr('src', '/wp-content/themes/biopods/img/yellow-star-hollow.svg');
			});
		}
	});

	$('.star-rating-select img').on('click', function(){
		var rating = $(this).data('rating');
		$('.star-rating-select img').each(function(){
			if($(this).data('rating') <= rating){
				$(this).attr('src', '/wp-content/themes/biopods/img/yellow-star.svg');
			}else{
				$(this).attr('src', '/wp-content/themes/biopods/img/yellow-star-hollow.svg');
			}
		});
		$(this).parents('.star-rating-select').addClass('selected');
		console.log('radio-' + rating.toString());
		$('#input_1_8').val('radio-' + rating.toString());
	});

	$('.btn--print').on('click',function(e){
		e.preventDefault();
		window.print();
	});

	$('body').on('click', '.mobile-order-toggle', function(){
		$('.checkout-flex-wrapper .cart--inner').toggleClass('is-open');
		$(this).toggleClass('is-open');
	});


	$('body').on('click', '.woocommerce-remove-coupon', function(e){
		e.preventDefault();
		var coupon_code = $(this).data('coupon');
		$.ajax({
		   type: "POST",
		   url: woocommerce_params.ajax_url,
		   data: {action : 'remove_coupon_from_cart','coupon_code' : coupon_code},
		   success: function (res) {
			   if (res) {
				   updateSideCart();
					 if($('.checkout-flex-wrapper').length){
						 setTimeout(function(){
				 			updateCheckoutCart();
				 		}, 1000);
					 }
				   // setTimeout(function(){
					//    $('.discount-field-input').append(res);
				   // }, 2000);
				  console.log('response', res);
			   }
		   }
		});
	});

	$('body').on('click', 'input[name="redeem-coupon"]', function(e){
		e.preventDefault();
		//$('#side-cart').addClass('is-loading');
		//var coupon_code = $('#coupon').val();
		var coupon_code = $(this).parents('.form-group').find('input[type="text"]').val();
		console.log(coupon_code);
		$.ajax({
		   type: "POST",
		   url: woocommerce_params.ajax_url,
		   data: {action : 'apply_coupon_to_cart','coupon_code' : coupon_code},
		   success: function (res) {
			   if (res) {
				   updateSideCart();

					 if($('.checkout-flex-wrapper').length){
						 updateCheckoutCart();
						 //$('.woocommerce-checkout-review-order-table').load();
						 //$(".woocommerce-checkout-review-order-table").load(location.href+" .woocommerce-checkout-review-order-table>*","");
						 var currentTime = new Date();
						 var current_timestamp = Date.parse(currentTime);
						 $(".woocommerce-checkout-review-order-table").load(location.href + '?time=' + current_timestamp + " .woocommerce-checkout-review-order-table>*","");
					 }
				   setTimeout(function(){
					   $('.discount-field-input').append(res);
				   }, 2000);
				  console.log('response', res);
			   }
		   }
		});
	});

//$('.tooltipped').tooltip();

$('body').on('click', '.cart[data-target="side-cart"]', function(e) {
	if( $(this).hasClass('is-empty') ) {
		console.log('toggle open');
		// e.preventDefault();
		// e.stopPropagation();

		$(this).removeClass('is-empty');
		updateSideCart();

		// var cartInstance = M.Sidenav.getInstance( $('#side-cart').get(0) );
		// 	cartInstance.open();
	}else{
		console.log('toggle close');
		var cartInstance = M.Sidenav.getInstance( $('#side-cart').get(0) );
			cartInstance.close();
	}
});

$('body').on('click', '.cart-item-remove', function(){
	var cart_item_id = $(this).data('cart-item-id');
	$('#side-cart').addClass('is-loading');
	const updates = {};
	updates[cart_item_id] = 0;

	$.ajax({
	   type: "POST",
	   url: "/cart/update.js",
	   data: {
			updates: updates,
		},
	   success: function (res) {
		   if (res) {
			   updateSideCart();
				 updateCheckoutCart();
				 console.log('remove item');
				 if($('.checkout-flex-wrapper').length){
					 updateCheckoutCart();
					 //$(".woocommerce-checkout-review-order-table").load(location.href+" .woocommerce-checkout-review-order-table>*","");
					 var currentTime = new Date();
					 var current_timestamp = Date.parse(currentTime);
					 $(".woocommerce-checkout-review-order-table").load(location.href + '?time=' + current_timestamp + " .woocommerce-checkout-review-order-table>*","");
				 }
		   }
	   }
	});

});

// Get cart count on page load
getCartCount();

// Set footer currency switcher on page load
getFooterCurrency();

// Get account info
// getHeaderAccount();

$('.resource-collapsible .collapsible-header a').on('click', function(e){
	e.stopPropagation();
});
setTimeout(function(){ checkAllInputs(); }, 500);

$('.input-field input').on('blur', function(){
	checkAllInputs();
	//console.log('check input');
});

function checkAllInputs(){

	$('.input-field input').each(function(){
		var val = $(this).val();
		// console.log(val);
		//$(this).attr('placeholder', '');
		if(val == ""){
			$(this).parents('.input-field').find('label').removeClass('active');
		}
	});

	$('.input-field select').each(function(){
		$(this).parents('.input-field').find('label').addClass('active');
	});
}

$('body').on('focus', '.gfield', function(){
	$(this).find('label').addClass('active');
});

$('body').on('blur', '.gfield textarea', function(){
		var val = $(this).val();
		console.log(val);
		if(val == ""){
			$(this).parents('.gfield').find('label').removeClass('active');
		}else{
			$(this).parents('.gfield').find('label').addClass('active');
		}
});

$('body').on('blur', '.gfield input', function(){
		var val = $(this).val();
		console.log(val);
		if(val == ""){
			$(this).parents('.gfield').find('label').removeClass('active');
		}else{
			$(this).parents('.gfield').find('label').addClass('active');
		}
});

$('.gfield input').on('keyup', function(){
	var val = $(this).val();
	$(this).attr('placeholder', '');
	if(val == ""){

	}else{
		$(this).parents('.gfield').find('label').addClass('active');
	}
});

jQuery(document).on('gform_post_render', function(event, form_id, current_page){
	$('.gfield input').each(function(){
    	var val = $(this).val();
    	$(this).attr('placeholder', '');
    	if(val == ""){

    	}else{
    		$(this).parents('.gfield').find('label').addClass('active');
    	}
    });
	$('.input-field select').each(function(){
		$(this).parents('.input-field').find('label').addClass('active');
	});
        // code to trigger on form or form page render

});

/*if(!$('#registration-modal').length){
  $('.modal').modal({
      dismissible: true,
      onOpenEnd: function(modal, trigger) {
		  $('.modal.open iframe').each(function(){
			var modalUrl = $(this).data('url');
			$(this).attr('src', modalUrl + '?autoplay=1');
		  });
      },
      onCloseEnd: function() {
		  $('.modal iframe').each(function(){
  			  var modalUrl = $(this).data('url');
  			  $(this).attr('src', modalUrl);
  		  });
      }
    }
  );
}else{
  $('.modal').modal({
      dismissible: true,
  });
}*/

//modal-customize
var hash = window.location.hash;
if(hash) {
  if(hash == '#customize'){
	  console.log('customizer open');
	  var modalInstance = M.Modal.getInstance($('#modal-customize').get(0));
	  modalInstance.open();
  }
}

$('body').on('click', '.btn--modal-continue', function(){
	// var destination = $(this).attr('href');
	// window.location = destination;
	// console.log(destination);
	window.location.href += "customize";
	location.reload();
});

  $('.scrollto-link a').on('click', function(e){
    e.preventDefault();
    var el =  $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(el).offset().top
    }, 2000,"easeInOutExpo");
  });


  //360 view slider

  $('.slider-nav-360-item').on('click', function(){
    var index = $(this).data('index');
    $('.slider-nav-360-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.slider-360-view').slick('slickGoTo', index - 1);
		$('.slider-360-view-mobile').slick('slickGoTo', index - 1);
  });

  $('.slider-360-view').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    nextSlide = nextSlide + 1;
    $('.slider-nav-360-item').each(function(){
      var index = $(this).data('index');
      if(index == nextSlide){
        $('.slider-nav-360-item').removeClass('is-active');
        $(this).addClass('is-active');
      }
    });

    if(nextSlide == 3 || nextSlide == 1){
      $('.indicator-360').show();
    }else{
      $('.indicator-360').hide();
    }
  });

	$('.slider-360-view-mobile').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    nextSlide = nextSlide + 1;
    $('.slider-nav-360-item').each(function(){
      var index = $(this).data('index');
      if(index == nextSlide){
        $('.slider-nav-360-item').removeClass('is-active');
        $(this).addClass('is-active');
      }
    });

    if(nextSlide == 3 || nextSlide == 1){
      $('.indicator-360').show();
    }else{
      $('.indicator-360').hide();
    }
  });

setTimeout(function(){
  $('.flutter-animation').css('opacity', '1');
}, 1500);

$('.video-parent').on('click', function(){
  $(this).find('.video-thumbnail--wrapper').hide().addClass('hidden-important');
  $(this).find('.video-inline-wrapper').addClass('hidden-important');
  var vid = $(this).find('video');
  if(vid.length){
	  vid.show();
	  vid.get(0).play();
  }else{
	  var videoContainer = $(this).find('.embed-container');
	  videoContainer.show();
    var videoURL = videoContainer.find('iframe').attr('src');
    videoContainer.find('iframe').attr('src', videoURL + '?&autoplay=1&title=0&byline=0&portrait=0');
  }

});

$('.video-parent video').on('click', function(e){
  e.stopPropagation();
  console.log('dont play');
});

$('.starter-kit-thumbnail-slider').on('click', '.slick-slide img', function(){
  var imgSrc = $(this).attr('src');
  console.log(imgSrc);
  $(this).parents('.starter-kit-panel').find('.starter-kit-slider-image img').attr('src', imgSrc);
});

$('.mobile-only-order-summary').on('click', function(e){
  e.preventDefault();
  $('.hidden-by-accordion--mobile-only').toggleClass('is-active');
  $(this).toggleClass('is-active');
});

$('.is-mobile-accordion > h4').on('click', function(){
  $(this).parents('.is-mobile-accordion').toggleClass('is-open');
});

if($('.section--old-vs-new').length){
  var controller = new ScrollMagic.Controller();
  var scene = new ScrollMagic.Scene({
    triggerElement: ".section--old-vs-new"
  })
  .addTo(controller)
  .on('enter', function(e){
    $('.old-new-video-wrapper').each(function(){
      var video = $(this).find('video');
      video.currentTime = 0;
      video.get(0).play();
    });
  });
}


$('ul.footer-menu > li > a').on('click', function(e){
  e.preventDefault();
  $(this).parents('li').toggleClass('is-open');
});

  //$('.modal').modal();

  createMarginEquation();

   $(window).bind('resizeEnd', function() {
     createMarginEquation();
   });

   function createMarginEquation(){
     if($('.section--article-intro .article-image').length){
       var missingContentWidth = $('.section--article-intro').find('.grid-container .grid-x').outerWidth();
       $('.section--article-intro .article-image').css('margin-right', 'calc(((100vw - ' + missingContentWidth + 'px - 1.2rem)/2)*-1)');
     }
   }

   $(document).ready(function(){
     //$('.collapsible').collapsible();
   });



  /*$(".testimonial-slider").slick({
    infinite: true,
    arrows: true,
    dots: true,
    autoplay: false,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow: '<img src="//biopods.com/cdn/shop/t/341/assets/arrow-left.svg?v=47545" class="slick-prev">',
    nextArrow: '<img src="//biopods.com/cdn/shop/t/341/assets/arrow-right.svg?v=47545" class="slick-next">',
    responsive: [
      {
        breakpoint: 1330,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });


$('.starter-kit-thumbnail-slider').slick({
  infinite: true,
  arrows: true,
  dots: false,
  autoplay: false,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow: '<img src="/wp-content/themes/biopods/img/arrow-left--green.svg" class="slick-prev">',
  nextArrow: '<img src="/wp-content/themes/biopods/img/arrow-right--green.svg" class="slick-next">',
  responsive: [
    {
      breakpoint: 1330,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
  ]
});

  $(".testimonial-slider-one").slick({
    infinite: true,
    arrows: false,
    dots: true,
    autoplay: false,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<img src="//biopods.com/cdn/shop/t/341/assets/arrow-left.svg?v=47545" class="slick-prev">',
    nextArrow: '<img src="//biopods.com/cdn/shop/t/341/assets/arrow-right.svg?v=47545" class="slick-next">',
    responsive: [
      {
        breakpoint: 1330,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });


  $(".testimonial-slider-one--arrow").slick({
    infinite: true,
    arrows: true,
    dots: true,
    autoplay: false,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<img src="/wp-content/themes/biopods/img/slider-arrow-green-right.svg" class="slick-prev">',
    nextArrow: '<img src="/wp-content/themes/biopods/img/slider-arrow-green-left.svg" class="slick-next">',
    responsive: [
      {
        breakpoint: 1330,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });


  $(".slider-360-view").slick({
    infinite: true,
    arrows: true,
    dots: false,
    autoplay: false,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    draggable: false,
    prevArrow: '<img src="//biopods.com/cdn/shop/t/341/assets/arrow-left.svg?v=47545" class="slick-prev">',
    nextArrow: '<img src="//biopods.com/cdn/shop/t/341/assets/arrow-right.svg?v=47545" class="slick-next">',
  });


	$(".slider-360-view-mobile").slick({
    infinite: true,
    arrows: true,
    dots: false,
    autoplay: false,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    draggable: false,
    prevArrow: '<img src="//biopods.com/cdn/shop/t/341/assets/arrow-left.svg?v=47545" class="slick-prev">',
    nextArrow: '<img src="//biopods.com/cdn/shop/t/341/assets/arrow-right.svg?v=47545" class="slick-next">',
		responsive: [
      {
        breakpoint: 640,
        settings: {
          arrows: false
        }
      }
    ]
  });



	$('.dropdown-trigger').dropdown({
     'constrainWidth' : false,
     'container' : false,
     'coverTrigger' : false,
     'alignment' : 'left',
     'onOpenStart' : navOpenStart,
     'onCloseEnd' : navCloseEnd,
     'hover' : true,
   });







   $('#mobile-nav').sidenav();

   $('#side-cart').sidenav({
      edge: 'right',
    }
  );
*/


	//$('select').formSelect();

	$('label[for*="billing"]').addClass('active');
	$('label[for*="shipping"]').addClass('active');


});	// end jquery document ready





   function navOpenStart(){
     $('.dropdown-content').addClass('is-open');
   }

   function navCloseEnd(){
     $('.dropdown-content').removeClass('is-open');
   }



/*
 * ResizeEnd
 *
 * Example:
 * $(window).bind('resizeEnd', function() {
 *  console.log('resize ended 500ms ago');
 * });
 */

$(window).resize(function() {

    if(this.resizeTO) clearTimeout(this.resizeTO);

    this.resizeTO = setTimeout(function() {
        $(this).trigger('resizeEnd');
    }, 500);

});









function updateCheckoutCart() {
	// add a loading class to side cart
	$('.checkout-cart').addClass('is-loading');

	$.ajax({
	    url: woocommerce_params.ajax_url,
	    data: {
	    	action: 'get_checkout_cart_then_die',
	    },
	    success:function(data){
				//console.log(data);
	    	$('.checkout-cart').html(data).removeClass('is-loading');
				$('.checkout-cart .tooltipped').tooltip();
	    }
	});

	getCartCount();

	if($('.checkout-flex-wrapper').length){
		setTimeout(function(){
		 //$(".woocommerce-checkout-review-order-table").load(location.href+" .woocommerce-checkout-review-order-table>*","");
		 var currentTime = new Date();
		 var current_timestamp = Date.parse(currentTime);
		 $(".woocommerce-checkout-review-order-table").load(location.href + '?time=' + current_timestamp + " .woocommerce-checkout-review-order-table>*","");

		 //console.log('get checkout cart');
		 //console.log(location.href + '?time=' + current_timestamp + " .woocommerce-checkout-review-order-table>*");
	 }, 500);
	}
}



function updateSideCart() {
	// add a loading class to side cart
	$('#side-cart').addClass('is-loading');

	$.ajax({
	    url: "/?section_id=flyout-cart",
	    success:function(data){
				const cartHtml = new DOMParser()
        	.parseFromString(data, 'text/html')
					.querySelector("#side-cart").innerHTML;

	    	$('#side-cart').html(cartHtml).removeClass('is-loading');
				$('#side-cart .tooltipped').tooltip();

				window.SAWCartCheck()
	    }
	});

	getCartCount();
}


function updateFinalStage() {
	// add a loading class to side cart
	$('.modal.open #final-stage-checkout').addClass('is-loading');

	$.ajax({
	    url: woocommerce_params.ajax_url,
	    data: {
	    	action: 'get_final_stage',
	    },
	    success:function(data){
	    	$('.modal.open #final-stage-checkout').html(data).removeClass('is-loading').removeClass('init-hide');
			console.log(data);
			$('.modal.open #final-stage-checkout .tooltipped').tooltip();
			$('.appended-currency').each(function(){
				if($(this).parents('.cart_price').find('> ins .woocommerce-Price-amount.amount').length){
					console.log('sale');
					$(this).parents('.cart_price').find('> ins .woocommerce-Price-amount.amount').append($(this).html());
				}else{
					$(this).parents('.cart_price').find('> .woocommerce-Price-amount.amount').append($(this).html());
				}
			});
	    }
	});

	getCartCount();
}


function getCartCount(){
	$.ajax({
			url: "/?section_id=flyout-cart",
			success:function(data){
				const cartCount = new DOMParser()
					.parseFromString(data, 'text/html')
					.querySelector("[data-item-count]").innerHTML;

					if( cartCount != '0' ) {
							$('.site-header .cart-number span').html(cartCount).parent().addClass('is-active');
					} else {
						$('.site-header .cart-number span').html('').parent().removeClass('is-active');
					}
			}
	});

}

// $('.checkout-footer').each(function() {
// 	getFooterCurrency();
// });

function getFooterCurrency(){
	$('.site-footer, .checkout-footer').each(function() {

		// read the cookie
		var currency = getCookie('aelia_cs_selected_currency');
		// console.log('currency', currency);

		if( currency == '' ) {
			currency = 'USD';
		}

		$('.current-currency').html(currency);

		$('.get-stimsoles-price').each(function() {
			if(currency == 'USD'){
				$('.get-stimsoles-price.usd').addClass('shown');
			} else {
				$('.get-stimsoles-price.cad').addClass('shown');
			}
		});

		// force the active currency
		$('.currency_switch_form .currency_button.active').removeClass('active');
		$('.currency_switch_form .currency_button.' + currency).addClass('active');

		// $.ajax({
		//    type: "POST",
		//    url: woocommerce_params.ajax_url,
		//    data: {action : 'swap_course_to_correct_currency','currency' : currency},
		//    success: function (res) {
		// 	   if (res) {
		// 		   console.log(res);
		// 		   updateSideCart();
		// 		   updateCheckoutCart();
		// 			if($('.checkout-flex-wrapper').length){
		// 				updateCheckoutCart();
		// 				$(".woocommerce-checkout-review-order-table").load(location.href+" .woocommerce-checkout-review-order-table>*","");
		// 			}
		// 	   }
		//    }
		// });

	});



}


function getHeaderAccount(){
	$('.nav__item--account').each(function() {

		$.ajax({
		    url: woocommerce_params.ajax_url,
		    data: {
		    	action: 'get_header_account',
		    },
		    success:function(data){
		    	// update header
		    	$('.nav__item--account').html(data);

		    	$('.nav__item--account .dropdown-trigger').dropdown({
				     'constrainWidth' : false,
				     'container' : false,
				     'coverTrigger' : false,
				     'alignment' : 'left',
				     'onOpenStart' : navOpenStart,
				     'onCloseEnd' : navCloseEnd,
				     'hover' : true,
				});

				$('nav.top-nav').css('opacity', 1);
		    }
		});

	});
}

$('#registration-modal .rmagic-form').submit(function(){
	$('body').addClass('is-loading');
	if(!$('.rm-form-field-invalid-msg').length){
		// console.log('submitted form');
	}
});


setTimeout(function(){
	if($('body').find('.rmagic-form .alert-error').length){
		var modalInstance = M.Modal.getInstance($('#registration-modal').get(0));
		modalInstance.open();
		console.log('errors');
	}else{
		console.log('no errors');
	}
}, 1000);


if($('body').find('.rm-post-sub-msg').length){
	// console.log('has message');
	var text = $('.rm-post-sub-msg').text();
	// console.log(text);
	$('body').append('<div class="redirection-message"><h2>Success! Logging you in...</h2></div>');
	console.log('redirecting...');
	//var destination = $(this).attr('href');
	setTimeout(function(){
		window.location = '/my-account/';
	}, 5000);
}else{
	// console.log('has no message');
}

$('.appended-currency').each(function(){
	if($(this).parents('.cart_price').find('> ins .woocommerce-Price-amount.amount').length){
		// console.log('sale');
		$(this).parents('.cart_price').find('> ins .woocommerce-Price-amount.amount').append($(this).html());
	}else{
		$(this).parents('.cart_price').find('> .woocommerce-Price-amount.amount').append($(this).html());
	}
});

// $('body').on('mouseenter', '#wpsl-stores li', function(e){
// 	e.stopPropagation();
// 	console.log('stop prop');
// });

$('.checkout-cart-fields input').bind("keyup change", function(e) {
	//jQuery( 'body' ).trigger( 'update_checkout' );
	//updateCheckoutCart();
});

$( document ).on( 'updated_checkout', function() {
    updateCheckoutCart();
} );

$('body').on('click', '.cutsom-add-course-ajax', function(e){
	e.preventDefault();
	console.log('course ajax');
	var cart_item_id = '4213';
	var cart_item_quantity = '1';
	$.ajax({
	   type: "POST",
	   url: woocommerce_params.ajax_url,
	   data: {action : 'add_course_to_cart','cart_item_id' : cart_item_id,'cart_item_quantity' : cart_item_quantity},
	   success: function (res) {
		   if (res) {
			   console.log(res);
			   updateSideCart();
			   var cartInstance = M.Sidenav.getInstance( $('#side-cart').get(0) );
			   cartInstance.open();
		   }
	   }
	});
});






function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function cookieExists(cname) {
	console.log(document.cookie);
  var exists = document.cookie.indexOf(cname);
  console.log('Indexof', cname, exists);
  if( exists == -1 ) {
  	return false;
  }
  return true;
}
